import tinycolor from '../loaders/tinycolor2';

const BLUE = tinycolor('#0f87ff');
const WHITE = tinycolor('#fff');
const BLACK = tinycolor('#000');
const RED = tinycolor('#E32D19');

export default class Color {
  // TODO: find a clean way to integrate this with >>> src/styles/theme.js
  static get BLACK() {
    return BLACK.clone();
  }

  static get BLUE() {
    return BLUE.clone();
  }

  static get WHITE() {
    return WHITE.clone();
  }

  static get RED() {
    return RED.clone();
  }

  static toNumber(color) {
    return parseInt(color.toHex(), 16);
  }

  static getComplement(color) {
    return color.isLight() ? Color.BLACK : Color.WHITE;
  }
}
